import { GENDER } from "core/consts";
import { ValueOf } from "core/types";
import RadioGroupV2, { RadioOptionV2 } from "ds_legacy/components/RadioGroupV2";
import { RADIO_WHITE_BACKGROUND } from "ds_legacy/materials/colors";
import { padding, sizing } from "ds_legacy/materials/metrics";
import { FONT_SIZE_14, FONT_WEIGHT_BOLD } from "ds_legacy/materials/typography";
import {
  DatePickerWithLabel,
  Section,
  SectionRow,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SectionTwo = () => {
  const translations = useTranslations();

  const options: RadioOptionV2<ValueOf<typeof GENDER>>[] = [
    {
      label: translations.patientForms.drvGeneralForm.sectionTwo.male,
      value: GENDER.MALE,
    },
    {
      label: translations.patientForms.drvGeneralForm.sectionTwo.female,
      value: GENDER.FEMALE,
    },
    {
      label: translations.patientForms.drvGeneralForm.sectionTwo.diverse,
      value: GENDER.DIVERSE,
    },
    {
      label: translations.patientForms.drvGeneralForm.sectionTwo.unknown,
      value: GENDER.UNSPECIFIED,
    },
  ];

  return (
    <Section title={translations.patientForms.drvGeneralForm.sectionTwo.title}>
      <SectionRow customPadding={padding(1, 0, 0)}>
        <TextInputWithLabel
          elementName="patient_first_name"
          isBold
          isLarge
          label={translations.patientForms.drvGeneralForm.sectionTwo.firstName}
        />
        <TextInputWithLabel
          elementName="patient_last_name"
          isBold
          isLarge
          label={translations.patientForms.drvGeneralForm.sectionTwo.lastName}
        />
      </SectionRow>
      <SectionRow>
        <TextInputWithLabel
          elementName="patient_birth_name"
          isBold
          isLarge
          label={translations.patientForms.drvGeneralForm.sectionTwo.maidenName}
        />
        <TextInputWithLabel
          elementName="patient_maiden_name"
          isBold
          isLarge
          label={
            translations.patientForms.drvGeneralForm.sectionTwo.formerNames
          }
        />
      </SectionRow>
      <SectionRow>
        <RadioGroupV2
          elementName="gender_extended"
          formControlLabelSx={{ marginLeft: 0, paddingBottom: sizing(0.5) }}
          formLabelSx={{
            fontSize: FONT_SIZE_14,
            fontWeight: FONT_WEIGHT_BOLD,
            padding: padding(1, 0),
          }}
          label={translations.patientForms.drvGeneralForm.sectionTwo.gender}
          options={options}
          radioSx={RADIO_WHITE_BACKGROUND}
        />
      </SectionRow>
      <SectionRow>
        <TextInputWithLabel
          elementName="patient_street_housenumber"
          isBold
          isLarge
          label={translations.patientForms.drvGeneralForm.sectionTwo.street}
        />
        <TextInputWithLabel
          elementName="patient_zipcode"
          isBold
          label={translations.patientForms.drvGeneralForm.sectionTwo.zipCode}
        />
        <TextInputWithLabel
          elementName="patient_city"
          isBold
          isLarge
          label={translations.patientForms.drvGeneralForm.sectionTwo.city}
        />
      </SectionRow>
      <SectionRow>
        <DatePickerWithLabel
          elementName="patient_birthdate"
          isBold
          label={
            translations.patientForms.drvMedicalForm.sectionZero
              .dateBirthPatient
          }
        />
        <TextInputWithLabel
          elementName="patient_phone_number"
          isBold
          label={translations.patientForms.drvGeneralForm.sectionTwo.phone}
        />
        <TextInputWithLabel
          elementName="patient_nationality"
          isBold
          isLarge
          label={
            translations.patientForms.drvGeneralForm.sectionTwo.nationality
          }
        />
      </SectionRow>
    </Section>
  );
};
